module.exports = __webpack_public_path__ + "img/441.92189620.gif";